import * as LoginConstants from '../../login/constants';
import {Physician} from "../../../models/Physician";
import {defaultTenantModules} from "src/config/tenantModules";
import {defaultPermissions} from "src/config/permissions";

interface LoginState {
  error: string;
  isLoading: boolean;
  permissions: typeof defaultPermissions;
  tenantModules: typeof defaultTenantModules;
  user: Physician;
}

const initialState: LoginState = {
  user: null,
  isLoading: false,
  error: null,
  tenantModules: defaultTenantModules,
  permissions: defaultPermissions
};

export function login(state: LoginState = initialState, action): LoginState {
  switch (action.type) {
    case LoginConstants.PROCESSING:
      return {...state, user: null, isLoading: true, error: null};
    case LoginConstants.COMPLETE:
      return {...state, permissions: action.permissions, user: action.user, isLoading: false, error: null};
    case LoginConstants.FAIL:
      return {...state, permissions: initialState.permissions, user: null, isLoading: false, error: action.error};
    case LoginConstants.FETCH_TENANT_MODULES_STARTED:
      return {...state, tenantModules: initialState.tenantModules};
    case LoginConstants.FETCH_TENANT_MODULES_COMPLETED:
      return {...state, tenantModules: action.tenantModules};
    default:
      return state;
  }
}
